<template>
  <div>
    <heads :msg="$route.query.lesson_name"></heads>
    <div class="my_title">
      <p>{{ $route.query.rate==0?myTitle:myTitle1 }}</p>
    </div>
    <div v-if="feedback" class="msg">
      <p>您的反馈和评价有助于我们为您提供更好的学习服务</p>
    </div>
    <div v-if="feedback" class="my_textarea">
      <textarea id="" v-model="fellVal" name="" cols="30" rows="10"></textarea>
    </div>
    <div class="analyticScoring">
      <p>分项评分：<span>(匿名统计，所有人不可见)</span></p>
    </div>
    <div class="main">
      <div v-for="(i,t) in fellList" :key="t" class="main_items">
        <p>{{ i.name }}：</p>
        <p class="dissatisfied">不满意</p>
        <van-slider v-model="i.user_score" :min="0" :max="i.score" bar-height="4px" active-color="#ee2e2e" @change="upChange" />
        <p class="satisfied">很满意</p>
      </div>
    </div>
    <div class="my_submitBtn">
      <van-button color="#ee2e2e" type="primary" block @click="commits()">提交</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getSatisfaction, commits_surface } from '@/api/course.js'
import tool from '@/utils/tools.js'
import heads from '@/components/common/heads'

export default {
  components:{
    heads
  },
  data() {
    return {
      myTitle: '期中满意度调查',
      myTitle1: '期末满意度调查',
      RateValue: 0,
      SliderValue: 10,
      SliderValue1: 10,
      SliderValue2: 10,
      SliderValue3: 10,
      SliderValue4: 10,
      SliderValue5: 10,
      tarea: '',
      fellVal: '',
      fellList: '',
      feedback: ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const info = {
        lesson_id: this.$route.query.lesson_id,
        period: this.$route.query.rate == 0 ? 1 : 2
      }
      getSatisfaction(info).then(res => {
        this.fellList = res.result.define
        this.fellVal = res.result.info.user_post_comment
        this.feedback = res.result.info.feedback
        // res.result.forEach(item => {
        //   console.log(item, 'item')
        //   if (item.type == 1) {
        //     this.tarea = item.comment
        //     this.RateValue = Number(item.score)
        //   } else if (item.type == 2) {
        //     this.SliderValue = Number(item.score)
        //   } else if (item.type == 3) {
        //     this.SliderValue1 = Number(item.score)
        //   } else if (item.type == 4) {
        //     this.SliderValue2 = Number(item.score)
        //   } else if (item.type == 5) {
        //     this.SliderValue3 = Number(item.score)
        //   } else if (item.type == 6) {
        //     this.SliderValue4 = Number(item.score)
        //   } else if (item.type == 7) {
        //     this.SliderValue5 = Number(item.score)
        //   } else if (item.type == 8) {
        //     this.SliderValue6 = Number(item.score)
        //   }
        // })
      })
    },
    commits() {
      console.log(1)
      var status = this.fellList.every((item) => {
        return item.user_score == 0
      })
      if (status) {
        return this.$toast('您还未打分')
      }
      const quRate = this.$route.query.rate == 0 ? 1 : 2
      // const Arr = [
      //   { type: 2, score: this.SliderValue, name: '答疑满意度' },
      //   { type: 3, score: this.SliderValue1, name: '作业满意度' },
      //   { type: 4, score: this.SliderValue2, name: '视频满意度' },
      //   { type: 5, score: this.SliderValue3, name: '直播满意度' },
      //   { type: 6, score: this.SliderValue4, name: '班主任满意度' },
      //   { type: 7, score: this.SliderValue5, name: '推荐度' },
      //   { type: 8, score: this.SliderValue6, name: '试卷满意度' },
      //   { type: 1, score: this.RateValue, comment: this.tarea }
      // ]
      var params = {
        // lesson_id: 20151,
        lesson_id: this.$route.query.lesson_id,
        period: quRate,
        type: JSON.stringify(this.fellList),
        user_post_comment: this.fellVal
      }
      commits_surface(params).then(res => {
        Toast(res.result)
        if (res.errNo === 0) {
          this.go_back()
        }
      })
    },
    go_back() {
      // if (tool.isInApp()) {
      //   if (tool.isInIosApp()) {
      //     window.webkit.messageHandlers.vue_backApp.postMessage('app')
      //   } else {
      //     window.WebViewJavascriptBridge.callHandler(
      //       'vue_backApp'
      //       , '满意度调查表返回'
      //       , function(responseData) {
      //         // android 返参数接受
      //       }
      //     )
      //   }
      // } else {
      // this.$router.push({
      //   path: '/lesson_details',
      //   query: {
      //     lesson_id: this.$route.query.lesson_id,
      //     rate: 1
      //   }

      // })
      // }
      this.$router.go(-1)
    },
    onChange() {
      console.log(this.RateValue)
    },
    upChange(value) {
      Toast('当前值：' + value)
    }
  }
}
</script>

<style lang="scss" scoped>
.my_submitBtn{
  margin-top: 50px;
  width: 100%;
  height: 200px;
}
.dissatisfied{
  display: inline-block;
  font-size: 25px;
  color: #999999;
  position: relative;
  top:10px;
}
.satisfied{
  display: inline-block;
  font-size: 25px;
  color: #999999;
  position: relative;
  top:10px;
}
.analyticScoring p:nth-child(1){
  padding-left: 30px;
  font-size: 30px;
  span{
    color: #ccc;
  }
}
.main_items{
  width: 100%;
  height: 200px;
}
.main_items p{
  padding: 43px 0 0 30px;
  font-size: 30px;
}
// .analyticScoring p:nth-child(2){
//   padding: 43px 0 0 30px;
//   font-size: 30px;
// }
.analyticScoring{
  width: 100%;
  height: 74px;
}
.my_textarea{
  width: 100%;
  height: 280px;
  textarea{
    width: 690px;
    height: 189px;
    border: 1px solid #ccc;
    margin-left: 30px;
  }
}
  .Rate{
    width: 100%;
    height: 85px;
    overflow: hidden;
    p{
      display: inline-block;
      font-size: 30px;
      color: #999999;
      position: relative;
      bottom: 15px;
      padding: 0 0 0 35px;
    }
  }
  .my_header{
    height: 90px;
    width: 100%;
    background: #2a292d;
    display: flex;
    justify-content: space-between;
    img{
      width: 27px;
      height: 46px;
      margin: 24px 0 0 30px;
    }
  }
  .title{
    font-size: 30px;
    color: #fff;
    line-height: 90px;
    padding-right: 20px;
  }
  .my_title{
    width: 100%;
    height: 182px;
    background: url('../../assets/tit_img.png') no-repeat;
    background-size: 100%;
    p{
      color: #ee2e2e;
      font-size: 35px;
      font-weight: 600;
      text-align: center;
      padding-top: 45px;
    }
  }
  .msg{
    width: 100%;
    height: 60px;
    text-align: center;
    font-size: 30px;
  }
</style>

<style>
  .van-rate{
    margin-left: 20px;
  }
  .van-slider{
    width: 58%;
    margin-left: 35px;
    display: inline-block;
  }
  .van-button{
    margin: 0 auto;
    width: 91%;
  }
</style>
